import React from 'react';
import { Box } from '@mui/material';
import CustomSelect from 'app/components/CustomSelect';
import CustomInput from 'app/components/CustomInput';

const options = [
  { value: 'Alan hesab1', label: 'Alan hesab1' },
  { value: 'Alan hesab2', label: 'Alan hesab2' },
  { value: 'Alan hesab3', label: 'Alan hesab3' },
  { value: 'Alan hesab4', label: 'Alan hesab4' },
];

const PaymentDetailsCredit = () => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
      <Box sx={{ display: 'flex', gap: '28px' }}>
        <CustomSelect title={'Məxaric hesabı'} placeholder={'Məxaric hesabı'} options={options} />
        <CustomSelect
          title={'Komissiyanın məxaric hesabı'}
          placeholder={'Komissiyanın məxaric hesabı'}
          options={options}
        />
      </Box>
      <CustomInput title={'Məbləğ'} placeholder={'Məbləğ'} />
    </Box>
  );
};

export default PaymentDetailsCredit;
